import React from 'react';
import classNames from 'classnames';
import { Col, Row } from 'react-bootstrap';

import './RightPane.scss';
import { FormChangesUI } from '@praktio/common-ui';
import { RightPaneColumns } from '../../../utils/constants';

export interface IRightPaneHeaderProps {
  headerText: string;
  mainButton: JSX.Element;
  savedChanges: boolean;
  unsavedChanges: boolean;
  closeButtonAction: () => void;
}

export const RightPaneHeader = ({
  headerText,
  mainButton,
  savedChanges,
  unsavedChanges,
  closeButtonAction,
}: IRightPaneHeaderProps) => (
  <header className="RightPane-header d-flex justify-content-between align-items-center">
    <span className="headerText mb-0">{headerText}</span>
    <div className="RightPane-header-right-content d-flex align-items-center">
      <FormChangesUI
        unsavedChanges={unsavedChanges}
        savedChanges={savedChanges}
        children={mainButton}
      />
      <button className="RightPane-close-button" onClick={closeButtonAction} aria-label="Close">
        <span className="material-icons">close</span>
      </button>
    </div>
  </header>
);

export interface IRightPaneProps {
  children?: React.ReactNode;
  open: boolean;
}

const RightPane = ({ children, open }: IRightPaneProps) => {
  return (
    <Col
      xs={RightPaneColumns.XS}
      md={RightPaneColumns.MD}
      lg={RightPaneColumns.LG}
      className={classNames('d-none p-0 h-100', {
        'd-block': open,
      })}
    >
      <aside className={classNames('RightPane h-100 w-100 pb-2 pt-0 px-3', { open })}>
        {children}
      </aside>
    </Col>
  );
};

export default RightPane;
